import { trigger, transition, style, animate } from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({ transform: 'translateY(100%)', opacity: 1 }),
    animate(
      '380ms cubic-bezier(0.4,0,0.2,1)',
      style({ transform: 'translateY(0)', opacity: 1 })
    ),
  ]),
  transition(':leave', [
    animate(
      '320ms cubic-bezier(0.4,0,0.2,1)',
      style({ transform: 'translateY(100%)', opacity: 1 })
    ),
  ]),
]);

export const slideUpFast = trigger('slideUpFast', [
  transition(':enter', [
    style({ transform: 'translateY(24px)', opacity: 0 }),
    animate('180ms cubic-bezier(0.2, 0, 0.2, 1)', style({ transform: 'translateY(0)', opacity: 1 }))
  ]),
  transition(':leave', [
    animate('140ms cubic-bezier(0.4, 0, 1, 1)', style({ transform: 'translateY(24px)', opacity: 0 }))
  ])
]);